<template>
  <v-app id="app">
    <v-row class="logo" style="margin-top: -20px;">
      <a href="https://www.cutout.pro/" target="_blank">
        <img :src="logoB" style="width: auto;height: 30px;"/>
      </a>
    </v-row>
    <v-row class="head">
      <p style="font-size: 3.5rem;font-weight: bold;">AI Video Editor SDK</p>
      <p style="font-size: 2rem;">for web, iOS and android</p>
    </v-row>
    <v-row style="justify-content: center;margin-top: 80px;">
      <v-col cols="7">
        <video id="customStreamVideo" class="scale" style="height: 100%;width: 100%;object-fit: cover;"></video>
      </v-col>
      <v-col cols="2">
        <div class="background">
          <v-col cols="12" style="color: #000;font-size: 20px;font-weight: bold;display: flex;justify-content: center;">
            Background
          </v-col>
          <v-col cols="12" style="display: flex;justify-content: center;">
            <div class="background-img" @click="disable()" :class="{active: backgroundType == 0}">
              <v-icon>
                mdi-cancel
              </v-icon>
            </div>
          </v-col>
          <v-col cols="12" style="display: flex;justify-content: center;">
            <div class="background-img" @click="blur()" :class="{active: backgroundType == 1}">
              <v-icon>
                mdi-blur
              </v-icon>
            </div>
          </v-col>
          <v-col cols="12" v-for="(item, idx) in backgroundList" :key="'background_' + idx" style="display: flex;justify-content: center;">
            <div class="background-img" :class="{active: backgroundType == 'img_' + idx}">
              <img :src="item" @click="changeBackground(item, idx)"/>
            </div>
          </v-col>
        </div>
        <!--<a @click="start">start</a>
        <br /><br />
        <a @click="changeBackground">改背景</a>
        <br /><br />
        <a @click="disable">disable</a>
        <br /><br />
        <a @click="enable">enable</a>
        <br /><br />
        <a @click="stop">stop</a>
        <br /><br />
        <a @click="requestFrameRate">requestFrameRate</a>：{{ rate }}
        <br /><br />
        <a @click="blur">blur</a>-->
      </v-col>
    </v-row>
    <v-row class="bottom" style="font-size: 3.5rem;font-weight: bold;margin-top: 80px;">
      Contact Us
    </v-row>
    <v-row class="bottom" style="font-size: 2rem;">
      WhatsApp Business: +852 512 47178
    </v-row>
    <v-row class="bottom" style="margin-top: 30px;">
      <img :src="qrcode" style="width: auto;height: 200px;"/>
    </v-row>
  </v-app>
</template>

<script>
//import virtual from 'virtual-library';
import PicupVideoCutout from './plugins/index';
import qrcode from '@/assets/image/qrcode.jpg'
import logoB from '@/assets/image/logo-b.png'
import architecture from '@/assets/backgrounds/d1.jpg'
import porch from '@/assets/backgrounds/d6.jpg'
import saxon from '@/assets/backgrounds/a14.jpg'
import shibuyasky from '@/assets/backgrounds/a9.jpg'

let picupVideoBgSwapTest, i = 0, j = 0

export default {
  name: 'App',
  components: {},
  data() {
    return {
      rate: 30,
      backgroundList: [
        architecture,
        porch,
        saxon,
        shibuyasky,
      ],
      qrcode: qrcode,
      logoB: logoB,
      backgroundType: 1,
    }
  },
  mounted() {
    let customStreamVideo = document.getElementById('customStreamVideo');
		
		//暂时不生效和验证
		let token = "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
		//let background = "https://deeplor.oss-cn-hangzhou.aliyuncs.com/videosdk/bg/architecture-5082700_1280.jpg";
    let background = "blur";
    //let backend = 'wasmSimd'
    //let pipeline = 'webgl2'
    //let pipeline = 'canvas2dCpu'
		//let picupVideoBgSwapTest = new virtual(token, background, backend, pipeline);
    //try {
        picupVideoBgSwapTest = new PicupVideoCutout(token, background);
        picupVideoBgSwapTest.getOutputStream().then((videoSource) => {
            //以下代码示例演示了如何在video标签中使用该视频源
            console.log('picupVideoBgSwapTest-1', videoSource)
            customStreamVideo.srcObject = videoSource
            customStreamVideo.play()
        }).catch(function(err) {
            console.log('picupVideoBgSwapTest-err', err, err.name, err.message);
        });
    /*} catch (e) {
        console.log('catch-1', e);    //打印出Error对象：Error: loopTerminates
        console.log('catch-2', e.message); //打印：loopTerminates
    }*/
  },
  methods: {
    start() {
      let customStreamVideo = document.getElementById('customStreamVideo');
      
      //暂时不生效和验证
      let token = "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
      //let background = "https://deeplor.oss-cn-hangzhou.aliyuncs.com/videosdk/bg/architecture-5082700_1280.jpg";
      let background = "blur";
      picupVideoBgSwapTest = new PicupVideoCutout(token, background);
      picupVideoBgSwapTest.getOutputStream().then((videoSource) => {
          //以下代码示例演示了如何在video标签中使用该视频源
          console.log('picupVideoBgSwapTest-1', videoSource)
          customStreamVideo.srcObject = videoSource
          customStreamVideo.play()
      }).catch(function(err) {
          console.log('picupVideoBgSwapTest-err', err, err.name, err.message);
      });
    },
    changeBackground(img, idx) {
      if (img) {
        this.backgroundType = 'img_' + idx
        picupVideoBgSwapTest.changeBackground(img)
        return
      }
      let backgroundList = [
        "https://deeplor.oss-cn-hangzhou.aliyuncs.com/site/picup/cn-home/home/5.png",
        "https://deeplor.oss-cn-hangzhou.aliyuncs.com/upload/image/20200721/6ed6a205f75d4f4c88fb403700712191.jpg",
        "https://deeplor.oss-cn-hangzhou.aliyuncs.com/upload/image/20200721/117ec41b300c4e7e9ec22a1af76ca5e5.jpg",
        "https://deeplor.oss-cn-hangzhou.aliyuncs.com/videosdk/bg/architecture-5082700_1280.jpg"
      ]
      let background = backgroundList[i%4]
      picupVideoBgSwapTest.changeBackground(background)
      i++
    },
    disable() {
      this.backgroundType = 0
      picupVideoBgSwapTest.disable()
    },
    enable() {
      picupVideoBgSwapTest.enable()
    },
    stop() {
      picupVideoBgSwapTest.stop()
    },
    requestFrameRate() {
      let rateList = [
        5,
        10,
        15,
        30,
        45,
      ]
      let rate = rateList[j % rateList.length]
      this.rate = rate
      picupVideoBgSwapTest.requestFrameRate(rate)
      j++
    },
    blur() {
      this.backgroundType = 1
      picupVideoBgSwapTest.changeBackground('blur')
    },
  }
}
</script>

<style lang="scss">
#app {
  text-align: center;
  width: 1200px;
  margin: 60px auto;

  .head {
    justify-content: center;
    color: #000;
    align-items: center;
    flex-direction: column;

    p {
      margin-bottom: 0px;
    }
  }

  .background {
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    .background-img {
      width: 60px;
      height: 60px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(0, 0, 0, 0.23);
      border-radius: 4px;

      &.active {
        border: 1px solid #3f51b5;
      }

      img {
        object-fit: cover;
        width: calc(100% + 0px);
        height: calc(100% + 0px);
        margin: -1px;
        border-radius: 4px;
      }
    }
  }

  .bottom {
    justify-content: center;
    color: #000;
  }
}
</style>
